<ng-form #form="ngForm">
    @for (option of options; track option.data.id) {
    <div>
        @switch (option.type) {
        @case ('field') {
        <form-field [label]="option.data.title"
                    class="block m-t-6">
            <input type="text"
                   [name]="'option_' + option.data.id"
                   [maxlength]="option.data.max || null"
                   [required]="option.data.req"
                   [(ngModel)]="option.value"
                   autocomplete="off">
        </form-field>
        @if (option.data.max) {
        <p class="p-t-2 fs-4 flex flex-justify-between">
            <span class="p-r-2">Max {{option.data.max}} characters</span>
            {{ option.value?.length || 0 }} / {{option.data.max }}
        </p>
        }
        }
        @case ('area') {
        <form-field [label]="option.data.title"
                    class="block m-t-6">
            <textarea [name]="'option_' + option.data.id"
                      [maxlength]="option.data.max || null"
                      [required]="option.data.req"
                      [(ngModel)]="option.value"
                      autocomplete="off"></textarea>
        </form-field>
        @if (option.data.max) {
        <p class="p-t-2 fs-4 flex flex-justify-between">
            <span class="p-r-2">Max {{option.data.max}} characters</span>
            {{ option.value?.length || 0 }} / {{option.data.max }}
        </p>
        }
        }
        @case ('dropdown') {
        <form-field [label]="option.data.title"
                    class="block m-t-6">
            <select [name]="'option_' + option.data.id"
                    [required]="option.data.req"
                    [(ngModel)]="option.value"
                    autocomplete="off">
                <option [value]=""></option>
                @for (selection of option.values; track selection.value) {
                <option [value]="selection.value">
                    {{selection.title}}
                    @if(selection.price) {
                    - <price [value]="selection.price"></price>
                    }
                </option>
                }
            </select>
        </form-field>
        }
        @case ('radio') {
        <form-field [label]="option.data.title"
                    class="block m-t-6">
            <radio-group [name]="'option_' + option.data.id"
                         [(model)]="option.value"
                         [required]="option.data.req">
                @for (selection of option.values; track selection.value) {
                <radio-group-item [value]="selection.value">
                    {{selection.title}}
                    @if(selection.price) {
                    - <price [value]="selection.price"></price>
                    }
                </radio-group-item>
                }
            </radio-group>
        </form-field>
        }
        @case ('checkbox') {
        <form-field [label]="option.data.title"
                    class="block m-t-6">
            @for (selection of option.values; track selection.value) {
            <checkbox>
                <input type="checkbox"
                       [name]="'option_' + option.data.id + '_' + selection.value"
                       [(ngModel)]="selection.value">
                {{selection.title}}
                @if(selection.price) {
                - <price [value]="selection.price"></price>
                }
            </checkbox>
            }
        </form-field>
        }
        @case ('multiple') {
        <form-field [label]="option.data.title"
                    class="block m-t-6">
            @for (selection of option.values; track selection.value) {
            <checkbox>
                <input type="checkbox"
                       [name]="'option_' + option.data.id + '_' + selection.value"
                       [(ngModel)]="selection.value">
                {{selection.title}}
                @if(selection.price) {
                - <price [value]="selection.price"></price>
                }
            </checkbox>
            }
        </form-field>
        }
        }
    </div>
    }
</ng-form>